export default __webpack_public_path__ + "static/team_sasha-5260608d9f6cacbee59a237384cf7a84.jpg";